import sampleScale from '../assets/SampleScale.webp';
import ConveyerBeltPhoto from '../assets/ScaleImages/Conveyer Belt System.webp';
import JwelleryweighingScalePhoto from '../assets/ScaleImages/JwelleryScale.webp';
import PlatformWeighingPhoto from '../assets/ScaleImages/PlatformScale.webp';
import KitchenScalePhoto from '../assets/ScaleImages/KitchenScale.webp';
import TableTopWeighingPhoto from '../assets/ScaleImages/TabeTopScale.webp';
import TankWeighingPhoto from '../assets/ScaleImages/Tank Weighing System.webp';
import WeighBridgePhoto from '../assets/ScaleImages/Weigh Bridge.jpg';
import PLCAutomationPhoto from '../assets/ScaleImages/SmartIndicator.webp';
import IOTweighingSystemPhoto from '../assets/ScaleImages/Smart IOT Automation.webp';

export const products = [
    {
        id: "platform-weighing-scale",
        title: "Platform Weighing Scale",
        image: PlatformWeighingPhoto,
        sevenDayDelivery: true,
        description: "High-precision platform weighing scale suitable for industrial and commercial use.",
        moreDetails: "The platform weighing scale is designed to handle large loads with high accuracy, making it ideal for industrial and commercial applications. It features durable materials such as mild steel and stainless steel, ensuring longevity and reliability even in harsh environments. Its large platform size allows it to accommodate larger items, and the versatile display options make it easy to read measurements from a distance.",
        specifications: [
            { label: "Capacity offered", value: "10 KG, 20 KG, Upto 1 Ton" },
            { label: "Accuracy", value: "1 GM, 2 GM, 5 GM" },
            { label: "Platform size", value: "300x300mm, 600x600mm, 1m x 1m" },
            { label: "Material", value: "Mild Steel, Stainless Steel" },
            { label: "Display", value: "LED/LCD display with backlight" },
            { label: "Power supply", value: "Rechargeable battery and AC power" },
            { label: "Usage", value: "Industrial, Commercial, Retail" },
        ],
        models: [
            {
                title: "Max Weigh Platform Series",
                columns: ["Model No.", "Capacity (kg.)", "Accuracy (gms.)", "Platform Size (mm x mm)"],
                data: [
                    { model: "MWS - 30 - P", capacity: "30", accuracy: "5", size: "300 X 400" },
                    { model: "MWS - 50 - P", capacity: "50", accuracy: "5", size: "400 X 400" },
                    { model: "MWS - 100 - P", capacity: "100", accuracy: "10", size: "500 X 600" },
                    { model: "MWS - 120 - P", capacity: "120", accuracy: "10/20", size: "600 X 600" },
                    { model: "MWS - 150 - P", capacity: "150", accuracy: "20", size: "600 X 600" },
                    { model: "MWS - 200 - P", capacity: "200", accuracy: "20", size: "600 X 600" },
                    { model: "MWS - 300 - P", capacity: "300", accuracy: "50", size: "600 X 600" },
                    { model: "MWS - 500 - P", capacity: "500", accuracy: "50", size: "600 X 600" },
                ]
            },
            {
                title: "Max Weigh Heavy Duty MS Series",
                columns: ["Model No.", "Capacity (kg.)", "Accuracy (gms.)", "Platform Size (mm x mm)"],
                data: [
                    { model: "MWS - 300 - P", capacity: "300", accuracy: "50", size: "750 x 750" },
                    { model: "MWS - 500 - P", capacity: "500", accuracy: "50", size: "750 x 750" },
                    { model: "MWS - 1 - T - P", capacity: "1000", accuracy: "100", size: "1000 x 1000" },
                    { model: "MWS - 2 - T - P", capacity: "2000", accuracy: "200", size: "1200 x 1200" },
                    { model: "MWS - 3 - T - P", capacity: "3000", accuracy: "500", size: "1200 x 1500" },
                    { model: "MWS - 5 - T - P", capacity: "5000", accuracy: "500", size: "1200 x 1500" },
                ]
            }
        ],
    },
    {
        id: "conveyor-weighing-system",
        title: "Conveyor Weighing System",
        image: ConveyerBeltPhoto,
        sevenDayDelivery: false,
        description: "In-motion conveyor weighing system for precise weight measurements during material transfer.",
        moreDetails: "The conveyor weighing system is designed for dynamic weighing of materials as they move along a conveyor. It ensures precise weight measurement during the material transfer process, crucial for industries like mining, material handling, and bulk transport. This system is capable of handling high-speed conveyor belts and can integrate with SCADA systems for real-time data monitoring and control.",
        specifications: [
            { label: "Capacity offered", value: "Upto 200 Tons/hour" },
            { label: "Speed", value: "Adjustable conveyor speed" },
            { label: "Accuracy", value: "0.5%, 1%" },
            { label: "Material", value: "Stainless Steel" },
            { label: "Interface", value: "Integration with SCADA systems" },
            { label: "Usage", value: "Material handling, Mining, Bulk transport" },
        ],
    },
    {
        id: "kitchen-weighing-scale",
        title: "Kitchen Weighing Scale",
        image: KitchenScalePhoto,
        sevenDayDelivery: true,
        description: "Compact and stylish kitchen weighing scale for accurate measurement of ingredients.",
        moreDetails: "The kitchen weighing scale is perfect for measuring ingredients with precision in a home kitchen, bakery, or small restaurant. It’s designed with ease of use in mind, offering compact storage and a clear digital display. The tare function and auto-off feature add to its convenience, making it a great addition for anyone who needs accuracy in food preparation.",
        specifications: [
            { label: "Capacity offered", value: "1 KG, 2 KG, 5 KG" },
            { label: "Accuracy", value: "1 GM, 2 GM, 5 GM" },
            { label: "Platform size", value: "Small, Compact design for easy storage" },
            { label: "Material", value: "Plastic with stainless steel weighing tray" },
            { label: "Display", value: "Digital LCD display" },
            { label: "Power supply", value: "AAA batteries or USB power" },
            { label: "Features", value: "Tare function, Auto-off, Low battery indicator" },
            { label: "Usage", value: "Home kitchens, Bakeries, Small restaurants" },
        ],
    },
    {
        id: "table-top-weighing-scale",
        title: "Tabletop Weighing Scale",
        image: TableTopWeighingPhoto,
        sevenDayDelivery: true,
        description: "Compact and portable tabletop weighing scale ideal for retail and small-scale businesses.",
        moreDetails: "This compact and portable tabletop weighing scale is designed for accuracy and ease of use in retail and small-scale businesses. It’s lightweight, portable, and offers a variety of capacities and display options to suit different types of items. Its stainless steel platform is easy to clean, and the rechargeable battery ensures portability and convenience.",
        specifications: [
            { label: "Capacity offered", value: "1 KG, 5 KG, 10 KG" },
            { label: "Accuracy", value: "0.1 GM, 0.5 GM" },
        ],
        models: [
            {
                title: "Max Weigh Table Top Standard Series",
                columns: ["Model No.", "Capacity (kg.)", "Accuracy (gms.)", "Platform Size (mm x mm)"],
                data: [
                    { model: "MWS - 05 - T", capacity: "5", accuracy: "0.5", size: "250 X 300" },
                    { model: "MWS - 10 - T", capacity: "10", accuracy: "1", size: "250 X 300" },
                    { model: "MWS - 20 - T", capacity: "20", accuracy: "2", size: "250 X 300" },
                    { model: "MWS - 30 - T", capacity: "30", accuracy: "1/2/5", size: "250 X 300" },
                    { model: "MWS - 06/15", capacity: "6/15", accuracy: "2/5", size: "250 X 300" },
                ]
            }
        ],
    },
    {
        id: "jewellery-weighing-scale",
        title: "Jewellery Weighing Scale",
        image: JwelleryweighingScalePhoto,
        sevenDayDelivery: true,
        description: "Precision jewellery weighing scale designed for accurate measurements of precious metals and stones.",
        moreDetails: "The jewellery weighing scale is designed with high precision to provide accurate measurements for precious metals and gemstones. It’s ideal for jewellery shops and laboratories where precise weight readings are essential for accurate pricing. The scale features a high-resolution display and is built with stainless steel and glass materials, ensuring both durability and a sleek appearance.",
        specifications: [
            { label: "Capacity offered", value: "100 GM, 200 GM, 500 GM, 1 KG" },
            { label: "Accuracy", value: "0.01 GM, 0.02 GM" },
            { label: "Platform size", value: "100x100mm, 150x150mm" },
            { label: "Material", value: "Stainless Steel, Glass" },
            { label: "Display", value: "High-resolution LED display" },
            { label: "Power supply", value: "Rechargeable battery and USB power" },
            { label: "Usage", value: "Jewellery shops, Laboratories, Retail" },
        ],
        models: [
            {
                title: "Max Weigh Jewellery Series",
                columns: ["Model No.", "Capacity (gm.)", "Accuracy (mgs.)", "Platform Size (mm x mm)"],
                data: [
                    { model: "MWS - 100 - T", capacity: "100", accuracy: "5", size: "120 mm dia" },
                    { model: "MWS - 200 - T", capacity: "200", accuracy: "10", size: "120 mm dia" },
                    { model: "MWS - 300 - T", capacity: "300", accuracy: "10", size: "120 mm dia" },
                    { model: "MWS - 03 - T", capacity: "3000", accuracy: "100", size: "250 x 250" },
                ]
            }
        ],
    },
    {
        id: "weigh-bridge-scale",
        title: "Weighbridge",
        image: WeighBridgePhoto,
        sevenDayDelivery: false,
        description: "Reliable weighbridge system for measuring vehicle loads in industrial and commercial applications.",
        moreDetails: "Weighbridges are used to measure the weight of large vehicles such as trucks and trailers. These robust systems are designed to withstand high traffic and harsh environmental conditions. The weighbridge comes with high-capacity load cells and offers precise measurements, making it perfect for logistics, transportation, and mining applications.",
        specifications: [
            { label: "Capacity offered", value: "30 Tons, 50 Tons, 100 Tons" },
            { label: "Platform size", value: "6m x 3m, 12m x 3m, 18m x 3m" },
            { label: "Material", value: "Steel-concrete composite" },
            { label: "Accuracy", value: "10 KG, 20 KG" },
            { label: "Load cells", value: "High-capacity load cells with IP68 protection" },
            { label: "Usage", value: "Transportation, Logistics, Mining, Industrial" },
        ],
    },
    {
        id: "plc-automation-weighing-system",
        title: "PLC-Based Automation Weighing System",
        image: PLCAutomationPhoto,
        sevenDayDelivery: false,
        description: "Advanced weighing system integrated with PLC for automation in industrial applications.",
        moreDetails: "The PLC-based automation weighing system integrates programmable logic controllers (PLCs) to automate and control weighing processes in industrial settings. It provides high precision and customizable options, making it suitable for complex manufacturing processes. This system is widely used in automated production lines and process industries for efficient weight measurement and control.",
        specifications: [
            { label: "Capacity offered", value: "Customizable as per requirements" },
            { label: "Interface", value: "PLC integration with Modbus/Profibus" },
            { label: "Material", value: "Industrial-grade materials" },
            { label: "Accuracy", value: "High precision with customizable options" },
            { label: "Usage", value: "Process industries, Automated production lines" },
        ],
    },
    {
        id: "iot-weighing-systems",
        title: "IoT Weighing Systems",
        image: IOTweighingSystemPhoto,
        sevenDayDelivery: false,
        description: "Smart IoT-enabled weighing systems for real-time monitoring and data analytics.",
        moreDetails: "The IoT-enabled weighing systems provide real-time monitoring and data analytics by connecting to cloud platforms. These systems enable remote tracking and control of weighing operations, offering valuable insights for better decision-making and operational efficiency. With connectivity options such as Wi-Fi, Ethernet, and cellular, this system is perfect for smart factories and logistics.",
        specifications: [
            { label: "Connectivity", value: "Wi-Fi, Ethernet, Cellular" },
            { label: "Capacity offered", value: "Customizable for different applications" },
            { label: "Interface", value: "Integration with cloud platforms" },
            { label: "Material", value: "Industrial-grade materials" },
            { label: "Usage", value: "Smart factories, Logistics, Remote monitoring" },
        ],
    },
];
